import { gql } from "@apollo/client"

export const DELETE_BRANCH = gql`
  mutation($id: String!, $storeId: String!) {
    deleteBranch(id: $id, restaurantId: $storeId) {
      id
    }
  }
`
